import React, { useCallback, useState } from 'react';
import { Dialog } from '@mui/material';
import { AppDialogTitle } from '../../layout/appDialogTitle';
import { addNewTask } from '../../services/api/taskServices';
import { AppConfirmationSuccessful } from '../app/confirmation/appConfirmationSuccessful';
import { TaskForm } from './taskForm';
import { Project } from '../../models/project';

interface TaskDialog {
  isOpen: boolean;
  onClose(): void;
  onRequestSuccessfully(): void;
  project: Project | null;
}

export function TaskDialogAdd({
  isOpen,
  onClose,
  onRequestSuccessfully,
  project,
}: TaskDialog): JSX.Element {
  const [isOpenConfirmation, setIsOpenConfirmation] = useState<boolean>(false);
  const [isLoadingRequest, setIsLoadingRequest] = useState<boolean>(false);

  const postNewTask = useCallback(
    (newTask) => {
      setIsLoadingRequest(true);
      addNewTask({
        isAMS: newTask.isAMS,
        projectId: newTask.project?.id,
        name:
          typeof newTask.name === 'string' ? newTask.name : newTask.name.label,
        status: newTask.status,
      })
        .then(() => {
          onRequestSuccessfully();
          setIsOpenConfirmation(true);

          onClose();
        })
        .then(() => {
          setTimeout(() => {
            setIsOpenConfirmation(false);
          }, 1000);
        })
        .finally(() => setIsLoadingRequest(false));
    },
    [onRequestSuccessfully, onClose]
  );

  return (
    <>
      <Dialog open={isOpen} sx={{ borderRadius: '5px' }}>
        <AppDialogTitle title="Add Task" handleClose={onClose} />
        <TaskForm
          onSubmit={postNewTask}
          onClose={onClose}
          isLoading={isLoadingRequest}
          project={project}
          readOnly
        />
      </Dialog>
      <AppConfirmationSuccessful
        isOpen={isOpenConfirmation}
        message="Task added"
        onClose={onClose}
      />
    </>
  );
}
